
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research",
      function () {
        return require("private-next-pages/research/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research"])
      });
    }
  